import React, { useState, useRef, useEffect } from "react";
import { useLightBox } from "../contexts/lightBoxContext/lightBoxContext.js";
import useMediaQueries from "../hooks/useMediaQueries.js";
import { useMailView } from "../contexts/mailViewContext/mailViewContext.js";
import Icon from "../components/Elements/Icon/Icon.tsx";
import Progressbar from "../components/Reusable/Progressbar/Progressbar.js";

const useAudioControls = ({ item, feedView }) => {
  const { mobileCondition } = useMediaQueries();
  const { getCondition } = useLightBox();
  const { getAudioPlaySrc, setAudioPlaySrc, getMobileGridView } = useMailView();

  const [play, setPlay] = useState(false);
  const [volume, setVolume] = useState(80);
  const [progress, setProgress] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const audioRef = useRef();

  const handleClickIcon = (e) => {
    if (mobileCondition && !feedView && getMobileGridView()) {
      return;
    }
    setPlay(!play);
    if (item) {
      setAudioPlaySrc(item.PreviewSrc);
      e.stopPropagation();
    }
  };

  useEffect(() => {
    getCondition() && setPlay(false);
  }, [getCondition()]);

  useEffect(() => {
    if (item) {
      getAudioPlaySrc() !== item.PreviewSrc ? setPlay(false) : setPlay(true);
    }
  }, [getAudioPlaySrc()]);

  const handleSeek = (e, { isTimeLine, isVolume }) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    if (isTimeLine) audioRef.current.currentTime = (x / rect.width) * duration;
    if (isVolume) setVolume(Math.floor((x / rect.width) * 100));
  };

  useEffect(() => {
    return () => {
      setAudioPlaySrc(null);
      if (audioRef.current) {
        audioRef.current.ontimeupdate = () => {
          return null;
        };
        audioRef.current.pause();
      }
    };
  }, []);

  useEffect(() => {
    if (audioRef.current) audioRef.current.volume = volume / 100;
  }, [volume]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.ontimeupdate = () => {
        const persent =
          (audioRef.current.currentTime / audioRef.current.duration) * 100;
        setCurrentTime(audioRef.current.currentTime);
        setProgress(persent);
      };
      play ? audioRef.current.play() : audioRef.current.pause();
    }
  }, [play]);

  return {
    audioRef,
    play,
    volume,
    setVolume,
    progress,
    currentTime,
    duration,
    setDuration,
    handleClickIcon,
    handleSeek,
    TimeLine,
  };
};

export const TimeLine = ({ progress, handleSeek, ...rest }) => {
  return (
    <Progressbar
      completed={parseInt(progress)}
      color="#15B4D4"
      height="6px"
      animation={100}
      onClick={(e) => handleSeek(e, { isTimeLine: true })}
      {...rest}
    />
  );
};

export const VolumeBar = ({ volume, handleSeek, setVolume, ...rest }) => {
  const [volumeBarOpen, setVolumeBarOpen] = useState(true);
  return (
    <div className={`audio-volume-range ${volumeBarOpen ? "opened" : ""}`}>
      <Icon
        name={`Speaker-volume-${!volume ? "off" : "high"}-01`}
        white
        onClick={(e) => {
          e.stopPropagation();
          setVolume((prev) => (prev ? 0 : 100));
          // setVolumeBarOpen(!volumeBarOpen);
        }}
      />
      <Progressbar
        completed={parseInt(volume)}
        onClick={(e) => handleSeek(e, { isVolume: true })}
        color="#15B4D4"
        height="6px"
        animation="100"
        {...rest}
      />
    </div>
  );
};

export default useAudioControls;
